<template>
  <div class="list-holder">
    <table class="listtable">
      <thead v-if="named_fields && !is_empty">
        <tr>
          <th v-if="value" class="list-select"></th>
          <th v-for="(col, fld) in fields" :class="'th-' + fld">
            {{ $fields.label(col) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="!is_empty">
        <tr v-for="item in list" :class="{url: !!url}">
          <td v-if="value" class="list-select">
            <i :class="{checked:value.includes(item.id)}" @click="toggleValue(item.id)"></i>
          </td>
          <td v-for="(col, fld) in fields" :class="'td-' + fld">
            <template v-if="cellurl(col) && cellurl(col)(item)">
              <router-link :to="cellurl(col)(item)">
                <Cell
                  :name=fld
                  :item=item
                  :field=col
                  @updating=updating
                  @updated=updated
                />
              </router-link>
            </template>
            <template v-else>
              <Cell
                :name=fld
                :item=item
                :field=col
                @updating=updating
                @updated=updated
                @click.native="$emit('clicked', item, col)"
              />
            </template>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="named_fields && is_empty">
        <tr>
          <td :colspan="fields_count">{{ 'no_count' | trans }}</td>
        </tr>
      </tfoot>
      <tfoot v-if="$slots.tfoot">
        <slot name="tfoot" />
      </tfoot>
    </table>
    <Pages v-if="paginate" v-model="p" :pages=pages />
    <Loading v-if="loading" class="absolute" />
    <slot />
  </div>
</template>

<script>
  import Cell from './Cell.vue';
  import {list as pagination} from '@/helpers/mixins/pagination'

  export default {
    props: ['fields', 'items', 'url', 'paginate', 'value'],
    mixins: [pagination],
    components: {Cell},
    computed: {
      named_fields () {
        for (let field of Object.values(this.fields)) {
          if (this.$fields.label(field)) {
            return true;
          }
        }
        return false;
      },
      fields_count () {
        return Object.keys(this.fields).length;
      },
      is_empty () {
        if (!this.items) {
          return false;
        }
        if (Array.isArray(this.items)) {
          return !this.items.length;
        }
        return !Object.keys(this.items).length;
      },
    },
    methods: {
      updating () {
        this.$emit('updating');
        this.loading = true;
      },
      updated () {
        this.$emit('updated');
        this.loading = false;
      },
      cellurl(col) {
        if (typeof col === 'object' && col.hasOwnProperty('url')) {
          return col.url;
        } else if (this.url) {
          return this.url;
        } else {
          return null;
        }
      },
      toggleValue (id) {
        id = Number(id);
        var value = this.value || [];
        var index = value.indexOf(id);
        if (index > -1) {
          value.splice(index, 1);
        } else {
          value.push(id);
        }
        this.$emit('input', value);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list-holder {
    position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/helpers/components/display/Listtwo.vue